module.exports = __webpack_public_path__ + "img/noun_Eye_4382116.aad61101.svg";